import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button} from 'antd';
import { Row, Col, Spinner, Alert } from 'reactstrap';
import axios from '../../utils/request';

let postworkplace = [];
let postnameoption = [];
let workplaceoption = [];
let personIds = "";
let applyIds = "";
let jobIds = "";
let processId = "";
let tenantId = "";
let userId = "";
let workplace = "";
let postname = "";

export class NewHopeWorkPlace extends Component {    
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            postworkplace:[],
            postnameoption: [],
            workplaceoption:[],
            personIds: "",
            applyIds : "",
            jobIds: "",
            processId: "",
            tenantId: "",
            userId: "",
            workplace: "",
            postname: ""
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(tenantId, commonParamater);
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/NewHope/NewHopeWorkPLace", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "获取岗位列表失败！" + res.data.message
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        tenantId = resdata.baseinfo.tenantId;
                        userId = resdata.baseinfo.userId;
                        personIds = resdata.baseinfo.applicantIds;
                        applyIds = resdata.baseinfo.applyIds;
                        jobIds = resdata.baseinfo.jobIds;
                        processId = resdata.baseinfo.processId;
                        postworkplace = resdata.postworkplace;
                        let posts = resdata.postworkplace.map(obj => { return obj.extEmploymentPosts });
                        postnameoption = posts.filter(function (item, index) {
                            return posts.indexOf(item) === index
                        });
                        this.setState({
                            tenantId: tenantId,
                            userId: userId,
                            personIds: personIds,
                            applyIds: applyIds,
                            jobIds: jobIds,
                            processId : processId,
                            postworkplace: postworkplace,
                            postnameoption: postnameoption
                        })
                    } else {
                        errorMessage = "获取岗位列表为空！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = (values) => {
        tenantId = this.state.tenantId;
        userId = this.state.userId;
        applyIds = this.state.applyIds;
        workplace = this.state.workplace;
        postname = this.state.postname;
        postnameoption = this.state.postnameoption
        workplaceoption = this.state.workplaceoption
        const params = {
            tenantId,
            userId,
            applyIds,
            workplace,
            postname,
            postnameoption,
            workplaceoption
        }
        const bodyString = JSON.stringify(params);
        axios
            .post("/api/NewHope/UpdateApplyStatus", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "提交失败" + resback
                } else {
                    errorMessage = "提交成功"
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    postSelectedValue = (value) => {
        if (value !== "") {
            postname = value;
            let places = postworkplace.filter(item => item.extEmploymentPosts == value);
            workplaceoption = places.map(obj => { return obj.extWorkPlace });
            this.setState({
                postname: postname,
                workplace: "",
                workplaceoption: workplaceoption
            });
            //console.log(this.formRef);
            this.formRef.current.setFieldsValue({
                place: undefined,
            })
        }
    };

    placeSelectedValue = (value) => {
        if (value !== "") {
            workplace = value;
            this.setState({
                workplace: workplace
            })
        }
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div style={{ width: "80%", textAlign: "center", padding: "32px" }}>
                        <div><h2>确认录用信息</h2></div>
                        <Form onFinish={this.onFinish} ref={ this.formRef}>
                            <Form.Item
                                name="workpost"
                                label="录用岗位名称"
                                required
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择岗位',
                                    },
                                ]}
                            >
                                <Select showSearch
                                    name="postnameselect"
                                    placeholder="---请选择岗位---"
                                    onChange={this.postSelectedValue}
                                >
                                    {postnameoption.map(name => <Select.Option key={name}>{name}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="place"
                                label="工作地点"
                                required
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择岗位',
                                    },
                                ]}
                            >
                                <Select showSearch
                                    name="workplaceoption"
                                    placeholder="---请选择地点---"
                                    onChange={this.placeSelectedValue}
                                >
                                    {workplaceoption.map(name => <Select.Option key={name}>{name}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button type="prmary" htmlType="submit">提交</Button>
                            </Form.Item>
                        </Form>
                    </div>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight:"100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}